<template>
  <v-dialog
    v-model="show"
    max-width="1200px"
    persistent
    transition="dialog-bottom-transition"
  >
    <v-form ref="form" v-model="valid" :lazy-validation="lazy">
      <v-card>
        <v-toolbar dark color="primary">
          <v-btn icon dark @click="show = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title> Nuevo Tipo de Turno </v-toolbar-title>
        </v-toolbar>
        <v-card-text>
          <v-alert
            v-if="esPorDefecto"
            class="mt-4"
            color="purple"
            dark
            outlined
            dismissible
          >
            Está cargando el primer Tipo de Turno, por lo cual será también el
            Tipo de Turno por defecto.
          </v-alert>
          <v-row dense>
            <v-col cols="12" sm="4" md="4">
              <v-text-field
                v-model="nombreTipoTurno"
                prepend-icon="mdi-account"
                label="Nombre del Tipo de Turno *"
                maxlength="80"
                :rules="requiredRules"
                dense
                required
              ></v-text-field>
            </v-col>
            <v-col cols="9" sm="4" md="2">
              <v-text-field
                v-model="sigla"
                prepend-icon="mdi-account"
                label="Sigla"
                maxlength="2"
                dense
                required
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="4" md="6" class="tipo-turno-checkboxes">
              <v-checkbox
                class="ml-4 mt-2"
                v-model="porDefecto"
                label="Es tipo de turno por defecto"
                color="primary"
                :disabled="esPorDefecto"
                hide-details
              ></v-checkbox>
              <v-checkbox
                class="ml-4 mt-2"
                v-model="disponibleWeb"
                label="Disponible Web"
                color="primary"
                hide-details
              ></v-checkbox>
              <v-checkbox
                class="ml-4 mt-2"
                v-model="permiteMultiplesPacientes"
                label="Permite Múltiples Pacientes"
                color="primary"
                hide-details
              ></v-checkbox>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="3" sm="4">
              <v-select
                :items="intervalos"
                prepend-icon="mdi-calendar-multiple"
                v-model="duracion"
                label="Duración Turno (Para Turnos Web)"
                dense
              ></v-select>
            </v-col>
          </v-row>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="success"
            :disabled="!valid"
            @click.stop="guardarTipoTurno"
            >Guardar</v-btn
          >

          <v-btn color="error" @click.stop="show = false">Salir</v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>

<script>
import axios from "../../../axios-auth.js";

export default {
  data: (vm) => ({
    nombreTipoTurno: null,
    porDefecto: false,
    disponibleWeb: false,
    permiteMultiplesPacientes: false,
    sigla: "",
    valid: false,
    lazy: false,
    requiredRules: [(v) => !!v || "Dato obligatorio"],
    duracion: 1,
    intervalos: [1, 2, 3, 4, 5, 6],
  }),

  props: {
    visible: {
      type: Boolean,
    },
    esPorDefecto: {
      type: Boolean,
    },
  },

  computed: {
    show: {
      get() {
        this.porDefecto = this.esPorDefecto;
        return this.visible;
      },
      set(value) {
        if (!value) {
          this.$refs.form.resetValidation();
          this.vaciarModels();
          document.getElementsByClassName("v-dialog--active")[0].scrollTop = 0;
          this.$emit("close");
        }
      },
    },
  },

  methods: {
    guardarTipoTurno() {
      this.$swal({
        title: "Guardar Tipo de Turno",
        text: "¿Desea registrar el tipo de turno?",
        icon: "success",
        type: "success",
        showCancelButton: true,
        background: "#ececec",
        confirmButtonText: "Si",
        cancelButtonText: "No",
        showCloseButton: true,
        showLoaderOnConfirm: true,
      }).then((result) => {
        if (result.value) {
          //this.$swal('Turno g', 'You successfully deleted this file', 'success')

          const datosTipoTurno = {
            idInstitucion: this.$store.state.usuario.institucion.idInstitucion,
            nombreTipoTurno: this.nombreTipoTurno,
            porDefecto: this.porDefecto,
            sigla: this.sigla,
            disponibleWeb: this.disponibleWeb,
            duracion: this.duracion,
            permiteMultiplesPacientes: this.permiteMultiplesPacientes,
          };
          let self = this;
          axios
            .post("/Profesional/GuardarTipoTurno", datosTipoTurno)
            .then((response) => {
              if (response.data == "error") {
                self.showAlert({
                  icon: "error",
                  title: "Ya existe un tipo de turno registrado con ese nombre",
                  vm: self,
                });
              } else {
                self.$refs.form.resetValidation();
                self.vaciarModels();

                document.getElementsByClassName(
                  "v-dialog--active"
                )[0].scrollTop = 0;
                self.showAlert({
                  icon: "success",
                  title: "Tipo de Turno registrado exitosamente",
                  vm: self,
                });
                self.$emit("tipoTurnoRegistrado");
              }
            })
            .catch((error) => {
              self.showAlert({
                icon: "error",
                title: "El Tipo de Turno no pudo ser registrado",
                vm: this,
              });
            });
        } else {
          //this.$swal('Cancelled', 'Your file is still intact', 'info')
        }
      });
    },

    vaciarModels() {
      this.nombreTipoTurno = "";
      this.porDefecto = false;
      this.sigla = "";
      this.disponibleWeb = false;
      this.permiteMultiplesPacientes = false;
      this.duracion = 1;
    },

    showAlert(alertInfo) {
      alertInfo.vm.$swal.fire({
        icon: alertInfo.icon,
        title: alertInfo.title,
        showConfirmButton: false,
        background: "#ececec",
        timer: 2000,
      });
    },
  },

  created() {
    this.vaciarModels();
  },
};
</script>
<style scoped lang="scss">
.tipo-turno-checkboxes {
  display: flex;
  gap: 1rem;
  flex-wrap: wrap;
}
</style>
